<template>
  <div class="CadastroConfigList">
        <el-row >
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">    
    <el-table :data="list" empty-text="Sem dados!">
       <el-table-column
        prop="name"
        label="Tipo"
        width="180" >
      </el-table-column>
      <el-table-column label="Valor" width="150" >
        <template slot-scope="scope">
          <money  v-model="list[scope.$index].valor" v-bind="percentual" class="el-input el-input__inner"></money> 
        </template>
      </el-table-column>
      <el-table-column v-if="permissao.editar_configuracoes" label="Ação" >
        <template slot-scope="scope">
          <el-button  size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">Salvar</el-button>
        </template>
      </el-table-column>
    </el-table>
          </el-col>
        </el-row>
  </div>
</template>
<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";
import  {Money}  from "v-money";


// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  components:  {Money} ,
  data() {
    return {
      percentual: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        suffix: " %",
        masked: false /* doesn't work with directive */,
      },
      list: [],
      permissao: {},
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_configuracoes) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    axios
      .get(url + "/config/", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.list = response.data;
          for(let i=0; i<response.data.length;i++){
              if(response.data[i].slug == 'comissao_interna'){
                this.list.splice(i, 1);
              }
              if(response.data[i].slug == 'comissao_externa'){
                this.list.splice(i, 1);
              }
          }
        }
      })
      .catch((err) => {
        this.total = "erro" + err;
      });
  },
  methods: {
    //FIM CADASTRO DADOS
    handleEdit(index, row) {
      let id = row.id;
          let dados = {
            valor: row.valor,
          };
          axios
            .put(url + "/config/" + id, dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then((resp) => {
              console.log(resp.data);
              this.$notify({
                title: "Sucesso",
                message: "Registro Alterado com sucesso!",
                type: "success",
              });
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao cadastrar os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });      
    },
  },
};
</script>
